var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCloseCamera = function SvgIconCloseCamera(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b35cf49d-65f1-45c2-af9a-5860be693dea",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .uuid-74490a53-cea4-4539-b816-7e70dcefa895{fill:#393939;isolation:isolate;opacity:.6;}.uuid-74490a53-cea4-4539-b816-7e70dcefa895,.uuid-493b2620-03f4-480d-8d7a-494e0af19668{stroke-width:0px;}.uuid-493b2620-03f4-480d-8d7a-494e0af19668{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-759cd432-84eb-4aaa-a7ed-1b3618a9e7b4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "uuid-dbba417e-3e4b-49ca-b250-9793631a457b",
    className: "uuid-74490a53-cea4-4539-b816-7e70dcefa895",
    cx: 20,
    cy: 20,
    r: 19.83
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-493b2620-03f4-480d-8d7a-494e0af19668",
    d: "M21.4,20l8.72-8.72c.39-.39.39-1.01,0-1.4s-1.01-.39-1.4,0l-8.72,8.72-8.72-8.72c-.39-.39-1.01-.39-1.4,0s-.39,1.01,0,1.4l8.72,8.72-8.72,8.72c-.39.39-.39,1.01,0,1.4.19.19.45.29.7.29s.51-.1.7-.29l8.72-8.72,8.72,8.72c.19.19.45.29.7.29s.51-.1.7-.29c.39-.39.39-1.01,0-1.4l-8.72-8.72Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCloseCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-closeCamera.dcb721856b83286d81dc56733b3b3175.svg";